<template lang="pug">
.ads-useful-info
  .ads-useful-info__title(v-if='isShowTitle') {{ title }}
  .ads-useful-info__articles
    ArticleCardSmall.ads-useful-info__article(
      v-for='(article, index) of items',
      :key='`${article.id}_${index}`',
      v-bind='useArticleProps(article)',
      :loadingViews='getLoadingViews(article.id)',
      coverSize='',
      @click-on-restore-button='updateViewsCount(article.id)',
      @favorite-delete='(favorite) => { onFavoriteDelete(favorite, article, false); }',
      @favorite-create-folder-and-add='(nameFolder) => onFavoriteCreateFolderAndAdd(nameFolder, article, update)',
      @favorite-create-folder-and-transfer='(nameFolder, favorite) => { onFavoriteCreateFolderAndTransfer(nameFolder, favorite, article, update); }',
      @favorite-transfer-to-folder='(favorite, folder) => onFavoriteTransferToFolder(favorite, folder, article, update)',
      @favorite-add-to-folder='(folder) => onFavoriteAddToFolder(folder, article)',
      @favorite-deferred='onFavoriteDeferred'
    )
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import ArticleCardSmall from '@/components/lh-ui/ArticleCard/ArticleCardSmall/ArticleCardSmall.vue';
  import { useArticlesStore } from '~/store/articles';
  import { useFavorite } from '@/composables/useFavoriteMethods';
  import { useUpdatingViewsCount } from '@/composables/useUpdatingViewsCount';
  import { useArticleProps } from '~/composables/useArticleProps';

  export default defineNuxtComponent({
    name: 'AdsUsefulInfo',

    components: {
      ArticleCardSmall,
    },

    provide() {
      return {
        isDateShowArticleCardSmall: () => false,
      };
    },

    props: {
      elem: {
        type: Object as PropType<TContent>,
        required: true,
      },
    },

    async setup(props) {
      const {
        onFavoriteDelete,
        onFavoriteCreateFolderAndAdd,
        onFavoriteCreateFolderAndTransfer,
        onFavoriteTransferToFolder,
        onFavoriteAddToFolder,
        onFavoriteDeferred,
      } = useFavorite();
      const { loadingViewsIds, updateViewsCount, getLoadingViews } = useUpdatingViewsCount();

      const includes = props.elem.attributes.items;

      const articlesStore = useArticlesStore();
      await articlesStore.fetchCommentsCount(includes);
      await articlesStore.fetchViewsCount(includes);

      return {
        useArticleProps,
        onFavoriteDelete,
        onFavoriteCreateFolderAndAdd,
        onFavoriteCreateFolderAndTransfer,
        onFavoriteTransferToFolder,
        onFavoriteAddToFolder,
        onFavoriteDeferred,
        loadingViewsIds,
        updateViewsCount,
        getLoadingViews,
      };
    },

    computed: {
      title(): string {
        return this.elem.attributes.title ?? 'Полезная информация';
      },

      items(): IArticle[] {
        return this.elem.attributes.posts;
      },

      isShowTitle(): boolean {
        // Временно отключаем заголовок https://app.clickup.com/t/86bz3gv3p
        return false;
      },
    },

    mounted() {
      const includes = this.items.map((item) => item.id);

      useArticlesStore().fetchAndSetFavorites({
        post_ids: includes.join(),
        per_page: includes.length,
      });
    },

    methods: {
      useArticleProps,
    },
  });
</script>

<style lang="scss" scoped>
  .ads-useful-info {
    padding-bottom: 8px;

    @include tablet {
      padding-bottom: 0;
    }

    &__title {
      @include fontH1;
      margin-bottom: 16px;
    }

    &__articles {
      margin-left: -16px;
      margin-right: -16px;

      @include tablet {
        margin-left: -24px;
        margin-right: -24px;
      }
    }

    &__article {
      & + & {
        position: relative;

        &:before {
          content: '';
          left: 0;
          top: 0;
          width: 100%;
          display: block;
          position: absolute;
          border-top: 1px solid #e7e7e7;
        }
      }
    }
  }
</style>
